require('./src/css/global.scss');
require('@ahaui/css/dist/index.min.css');
exports.wrapPageElement = require('./src/wrap-page');
